import ScreenResolution from '../../utils/screen-resolution';

export default class Visualiser {
    constructor(parent) {
        this.parent = parent;
        this.locale = HONDA.CarConfigurator.locale;
        this.el = parent.el.querySelector('.configurator--visualiser');
        this.iframe = this.el.querySelector('iframe');
        this.view = 'exterior';
        this.page = this.iframe.src;
        this.data = parent.data;
        this.car = parent.car;
        this.setScreenSize();
        this.bind();
    }

    bind() {
        this.onResize();
        this.onScrollHandler();
    }

    update() {        
        const car = this.car.data();
        const colourTrim = this.car.colourTrim();
        const path = `#${this.view}?mtoce=${this.car.mtoce()}&model=${this.data?.model?.modelBodyCode}&grade=${car.gradeCode}&engine=${car.engineCode}&transmission=${car.transmissionCode}&colour=${colourTrim.colour}&trim=${colourTrim.trim}&accessories=${this.car.accessories.join(',')}&region=${this.locale}`;
        this.iframe.contentWindow.location.replace(this.page + path);        
    }

    exterior() {
        this.view = 'exterior';
        this.update();
    }

    interior() {
        this.view = 'interior';
        this.update();
    }

    setScreenSize() {
        this.isTabletView = ScreenResolution.isTabletL();
        this.isPortrait = ScreenResolution.isPortrait();
    }

    onResize() {
        window.addEventListener('resize', () => {
            this.setScreenSize();
            this.scrollAction();
        });
    }

    scrollAction() {
        if (this.isTabletView && this.isPortrait) {
            const currentScroll = window.scrollY;
            if (currentScroll > 70) {
                this.el.classList.add('visualiser-small-view');
            } else {
                this.el.classList.remove('visualiser-small-view');
            }
        } else {
            this.el.classList.remove('visualiser-small-view');
        }
    }

    forceScrollAction() {
        if (this.isTabletView && this.isPortrait) {
            this.el.classList.add('visualiser-small-view');
        } else {
            this.el.classList.remove('visualiser-small-view');
        }
    }

    onScrollHandler() {
        window.addEventListener('scroll', () => {
            this.scrollAction();
        });
    }

    toggle(sectionId) {
        if (sectionId === 'grade-engine' || sectionId === 'exterior' || sectionId === 'interior') {
            this.el.classList.remove('visualiser-small-view-hide');
        } else {
            this.el.classList.add('visualiser-small-view-hide');
        }
    }
}
